import { createAction } from 'redux-actions';

const hideNotification: any = createAction('COOKIE_HIDE_NOTIFICATION', () => null);

export { hideNotification };
